import { Link } from '@mui/material';
import { styled, Box } from '@mui/system';

export const ExternalLinkInline = styled(Link)(() => ({
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline'
  },
  display: 'inline-block'
}));

export const SocialMediaContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  margin: '1rem 0 0 0'
}));
